// Retired rate-card URLs still contain bearer tokens; keep them out of telemetry.
const PRIVATE_RATE_CARD_PATH_PATTERN = /^\/rate-card(?:\/[^/?#]+)?(?:[/?#]|$)/;
const PRIVATE_CAMPAIGN_PATH_PATTERN = /^\/campaign(?:\/[^/?#]+)?(?:[/?#]|$)/;

function pathnameFrom(value: string): string {
  if (!value.startsWith('http://') && !value.startsWith('https://')) return value;
  try {
    return new URL(value).pathname;
  } catch {
    return value;
  }
}

/** Credential-bearing links and private conversations excluded from browser telemetry. */
export function isPrivateBearerRoute(value: string): boolean {
  const pathname = pathnameFrom(value);
  return (
    /^\/(?:view|dashboard\/enquiries|brands\/(?:dashboard|signin))(?:[/?#]|$)/.test(pathname) ||
    PRIVATE_RATE_CARD_PATH_PATTERN.test(pathname) ||
    PRIVATE_CAMPAIGN_PATH_PATTERN.test(pathname) ||
    /^\/(?:kit-preview|bespoke)(?:[/?#]|$)/.test(pathname)
  );
}

export function redactPrivateBearerPath(pathname: string): string {
  return (
    pathname
      .replace(/^\/bespoke\/[^/?#]+/, '/bespoke/[private]')
      .replace(/^\/kit-preview\/[^/?#]+/, '/kit-preview/[private]')
      .replace(/^\/brands\/signin(?:[/?#].*)?$/, '/brands/signin')
      .replace(/^\/brands\/dashboard(?:[/?#].*)?$/, '/brands/dashboard/[private]')
      // Retired rate-card links still carry share tokens when someone opens an old URL.
      .replace(/^\/rate-card\/[^/?#]+/, '/rate-card/[private]')
      .replace(/^\/view\/[^/?#]+/, '/view/[private]')
      // Share viewers call these APIs with the same bearer ID as `/view/<id>`.
      .replace(/^\/api\/share\/[^/?#]+/, '/api/share/[private]')
      .replace(/^\/campaign\/[^/?#]+/, '/campaign/[redacted]')
  );
}

/** Billing and enquiry forms are excluded from browser telemetry and session replay. */
export function isTelemetryProtectedRoute(value: string): boolean {
  return (
    /^\/(?:admin\/acquisition|claim-kit|my-kit|creator-kit|api\/(?:kit-preview|my-kit|admin\/acquisition))(?:[/?#]|$)/.test(
      pathnameFrom(value),
    ) ||
    isPrivateBearerRoute(value) ||
    /^\/dashboard\/(?:link-in-bio\/)?plan(?:[/?#]|$)/.test(pathnameFrom(value))
  );
}

/** Public creator pages need no account session or consent banner. */
export function isPublicBioRoute(value: string): boolean {
  return /^\/bio\/[^/?#]+\/?(?:[?#]|$)/.test(pathnameFrom(value));
}
